<template>
  <div
    class="list section"
    :style="sectionStyle"
  >
    <div class="container flex column items-center">
      <div
        v-if="title"
        class="row q-mb-xl"
      >
        <div
          class="text-center col-12 q-mb-lg"
          :style="titleStyle"
          v-html="$options.filters.pureHtml(title)"
        />
        <div class="bottom-line border-radius-6 offset-3 col-6"/>
      </div>

      <div class="q-gutter-y-lg">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="row relative-position"
        >
          <q-img
            :src="item.photoUrl"
            class="absolute-left q-my-auto xs-hide"
            width="200px"
            height="200px"
          />
          <div
            class="col-sm-11 col-12 offset-sm-1 list-body"
            :style="itemStyles"
          >
            <div
              class="q-mb-sm"
              :style="sublabelStyle"
              v-html="$options.filters.pureHtml(item.sublabel)"
            />
            <div
              :style="descriptionStyle"
              v-html="$options.filters.pureHtml(item.description)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import backgroundMixin from './mixins/backgroundMixin';
import descriptionMixin from './mixins/descriptionMixin';
import itemBorderMixin from './mixins/itemBorderMixin';
import sublabelMixin from './mixins/sublabelMixin';
import titleMixin from './mixins/titleMixin';

export default {
  name: 'ListSection',
  mixins: [
    backgroundMixin,
    descriptionMixin,
    itemBorderMixin,
    sublabelMixin,
    titleMixin,
  ],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.list {
  padding-bottom: 90px !important;

  .bottom-line {
    height: 6px;
    background: var(--active-color);
  }

  &-body {
    padding: 55px 80px 50px 150px;
    @media (max-width: $breakpoint-sm-min) {
      padding: 24px;
    }
  }
}
</style>
